<div class="header bg-gradient-info pb-8 pt-5 pt-md-8">
    <div class="container-fluid">

    </div>
</div>
<!-- Page content -->
<div class="container-fluid mt--7">
    <!-- Table -->
    <div class="row">
        <div class="col">
            <div class="card shadow">
                <div class="card-header bg-white border-0">
                    <div class="row align-items-center" *ngIf="!loading_title">
                        <div class="col-8">
                            <h3 class="mb-0">Liste des {{custom_page.title}}</h3>
                            <span class="text-primary"><strong>Nom public : </strong>{{ studio?.name  }}</span><br>
                            <span class="text-primary"><strong>Nom privé : </strong>{{ studio?.private_name  }}</span><br>
                        </div>
                        <div class="col-4 text-right">
                            <button type="button" class="btn btn-xl btn-dark" (click)="back()"><i
                                    class="fa fa-angle-left"></i> Retour</button>
                            <button class="btn btn-xl btn-success" [routerLink]="['/'+custom_page.endpoint+'/ajouter']"
                                [queryParams]="get_params_for_add()">ajouter une nouvelle heure d'ouverture</button>
                        </div>
                    </div>
                    <div class="row align-items-center mt-3">
                        <div class="col-4">
                            <div class="form-group row">
                                <div class="col-sm-4">
                                    <select class="form-control" [ngModel]="limit"
                                        (change)="change_limit($event.target.value)">
                                        <option value="4">4</option>
                                        <option value="10">10</option>
                                        <option value="25">25</option>
                                        <option value="50">50</option>
                                        <option value="100">100</option>
                                    </select>
                                </div>
                                <label class="col-sm-8 col-form-label ml-0 pl-0">Entrées par page</label>
                            </div>
                        </div>
                        <div class="col-4"></div>
                        <div class="col-4 text-right">

                        </div>
                    </div>
                </div>
                <div class="table-responsive">
                    <table class="table align-items-center table-flush">
                        <thead class="thead-light">
                            <tr>
                                <th scope="col" *ngFor="let element of columns">
                                    <span *ngIf="element.type != 'enum'">{{ element.value }}</span>
                                    <select class="form-control" *ngIf="element.type == 'enum'"
                                        (change)="change_filters(element.key ,$event)">
                                        <option value="{{ item.value }}" *ngFor="let item of element.list">{{ item.text
                                            }}</option>
                                        <option value="">Tous</option>
                                    </select>
                                </th>
                                <th scope="col"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of results">
                                <td *ngFor="let element of columns">
                                    <app-custom-col-table [item]="item" [element]="element"></app-custom-col-table>
                                </td>
                                <td class="text-right">
                                    <!-- call actions buttons -->
                                    <app-actions-table [index]="index" [row]="item" [visible_actions]="visible_actions"
                                        [invisible_actions]="invisible_actions" [endpoint]="custom_page.endpoint"
                                        [show_delete_button]="show_delete_button" [show_edit_button]="show_edit_button"
                                        [multi_actions]="multi_actions"></app-actions-table>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <p class="text-center font-weight-bold mt-3" *ngIf="loading">Chargement...</p>
                <p class="text-center font-weight-bold mt-3" *ngIf="results.length == 0 && !loading">Aucun élément
                    trouvé</p>
                <!-- Call pagination -->
                <div class="card-footer py-4"
                    *ngIf="results.length > 0 && !loading && nbr_pages > 1 && show_pagination">
                    <nav aria-label="...">
                        <ul class="pagination justify-content-end mb-0">
                            <li class="page-item">
                                <a class="page-link" href="javascript:void(0)" tabindex="-1"
                                    routerLink="/{{ currentLink }}" [queryParams]="generate_route_query(previous())">
                                    <i class="fas fa-angle-left"></i>
                                    <span class="sr-only">Previous</span>
                                </a>
                            </li>
                            <li class="page-item {{ (current_page == page) ? 'active' : '' }}"
                                *ngFor="let page of pageNums">
                                <a class="page-link" href="javascript:void(0)" *ngIf="checkIsNumber(page)"
                                    routerLink="/{{ currentLink }}" [queryParams]="generate_route_query(page)">{{
                                    page }}</a>
                                <span class="page-link" *ngIf="!checkIsNumber(page)">...</span>
                            </li>
                            <li class="page-item">
                                <a class="page-link" href="javascript:void(0)" routerLink="/{{ currentLink }}"
                                    [queryParams]="generate_route_query(next())">
                                    <i class="fas fa-angle-right"></i>
                                    <span class="sr-only">Next</span>
                                </a>
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>
        </div>
    </div>
</div>